import styles from './index.module.css'

import React from 'react'

import { Box, Flex, Tooltip } from 'components/ds'

export const NEW_COLUMN_TOOLTIP =
  'Hover over the number to see what playlists a track appears in'

// Header for the Appears on column with a dot marking it as newly released.
export const AppearsOnHeader = () => (
  <Flex align="center" gap="1">
    Appears on
    <Tooltip content={NEW_COLUMN_TOOLTIP} delayDuration={0} maxWidth="250px">
      <Box className={styles.newDot} data-testid="appears-on-new-dot" />
    </Tooltip>
  </Flex>
)
